// custom history object to allow navigation outside react components
export const routerHistory = {
    navigate: null,
    location: null
  };

/** Trim and lowercase email for consistent login / password-reset requests. */
export const normalizeEmail = (email) => {
  if (typeof email !== 'string') {
    return '';
  }
  return email.trim().toLowerCase();
};
